<template>
  <div
    class="status-tag"
    :class="statusToColorMap(status.name)"
    :style="[
      { color: status?.color },
      { backgroundColor: status?.backgroundColor },
    ]"
  >
    {{ status.label }}
  </div>
</template>
<script setup>
const props = defineProps({
  status: {
    type: Object,
    required: true,
  },
});

const statusToColorMap = (statusName) => {
  if (statusName === "in_work")
    return 'main';
  if (
    statusName?.trim()?.toLowerCase() === "declined" ||
    statusName?.trim()?.toLowerCase() === "отказался" ||
    statusName?.trim()?.toLowerCase() === "отказ" ||
    statusName?.trim()?.toLowerCase() === "отменено"
  )
    return 'red';
  if (statusName === "default" || statusName === "Согласовано")
    return 'gray';
  if (statusName === "Выполнено")
    return 'green';
  return 'main';
};
</script>

<style scoped lang="scss" >
.status-tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: left;
}
.main {
  color: $primary-main;
  background-color: $secondary-hover;
}

.red {
  color: $red-main;
  background-color: $red-secondary-main;
}

.gray {
  color: $gray;
  background-color: $light;
}

.green {
  color: $green;
  background-color: #26A6591A;
}
</style>
